import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-joiningdetails-grid',
  templateUrl: './joiningdetails-grid.component.html',
  styleUrls: ['./joiningdetails-grid.component.css']
})
export class JoiningdetailsGridComponent implements OnInit {

  title = "View Joining Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/serviceregister/joiningdetails/joiningdetails-grid/joiningdetails-grid.component.ts